import {
  addMember,
  archiveRole,
  assignRoles,
  createRole,
  getMember,
  listAssignments,
  listRoles,
  unassignRole,
  updateMember,
  updateRole,
} from "./endpoints";

export { service } from "./endpoints";
export {
  AddStaffMemberRequest,
  AssignStaffRolesRequest,
  CreateStaffRoleRequest,
  ListStaffRoleAssignmentsQuery,
  ListStaffRoleAssignmentsResponse,
  ListStaffRolesResponse,
  MAX_STAFF_PAY_CREDITS,
  MAX_STAFF_PAY_RAW,
  MonthlyPay,
  PayDate,
  StaffMember,
  StaffMemberParams,
  StaffMemberResponse,
  StaffRole,
  StaffRoleAssignment,
  StaffRoleAssignmentId,
  StaffRoleAssignmentIdParams,
  StaffRoleAssignmentResponse,
  StaffRoleAssignmentsResponse,
  StaffRoleId,
  StaffRoleIdParams,
  StaffRoleResponse,
  StaffRoleSummary,
  UpdateStaffMemberRequest,
  UpdateStaffRoleRequest,
} from "./schemas";

export const contract = {
  roles: { list: listRoles, create: createRole, update: updateRole, archive: archiveRole },
  assignments: { list: listAssignments, create: assignRoles, delete: unassignRole },
  members: { create: addMember, get: getMember, update: updateMember },
} as const;
